import { ReactElement } from 'react'
import { useWatch } from 'react-hook-form'
import DifferenceIcon from '@mui/icons-material/Difference'
import { TooltipIconButton } from '@ui/feedback'

interface XYCopyButtonProps {
  /** Form field name of the point (e.g. "globalStart") */
  name: string
}

const XYCopyButton = ({ name }: XYCopyButtonProps): ReactElement => {
  const position = useWatch({ name })

  const handleCopyXY = async () => {
    if (position == null || typeof position.x !== 'number' || typeof position.y !== 'number') return
    try {
      await navigator.clipboard.writeText(JSON.stringify({ x: position.x, y: position.y }))
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('Failed to copy XY coordinates:', error)
    }
  }

  return (
    <TooltipIconButton
      tooltip="XY kopieren"
      onClick={handleCopyXY}
      size="small"
      tooltipProps={{ placement: 'bottom' }}
      sx={{ padding: 0 }}
    >
      <DifferenceIcon fontSize="small" />
    </TooltipIconButton>
  )
}

export default XYCopyButton
